import * as i0 from '@angular/core';
import { Injectable, NgModule, Inject, Component, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { of, BehaviorSubject, Subject, forkJoin, combineLatest, firstValueFrom } from 'rxjs';
import { map, catchError, filter, takeUntil, tap, switchMap } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i1$1 from '@angular/router';
import { NavigationEnd } from '@angular/router';
let Rtl2SsoInterface = /*#__PURE__*/(() => {
  class Rtl2SsoInterface {
    static {
      this.ɵfac = function Rtl2SsoInterface_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SsoInterface)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2SsoInterface,
        factory: Rtl2SsoInterface.ɵfac
      });
    }
  }
  return Rtl2SsoInterface;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Status$1 = class Status {
  constructor(token, userId, uid, app, access, created, rtl2Roles) {
    this.token = token;
    this.userId = userId;
    this.uid = uid;
    this.app = app;
    this.access = access;
    this.created = created;
    this.rtl2Roles = rtl2Roles;
  }
};
let StatusRespMsg$1 = class StatusRespMsg {
  constructor(status) {
    this.status = status;
  }
};
let UserProfile$1 = class UserProfile {
  constructor(init) {
    Object.assign(this, init);
    this.ldapRoles = this.ldapRoles || [];
    this.pkvwRoles = this.pkvwRoles || [];
    this.rtl2Roles = this.rtl2Roles || [...this.pkvwRoles, ...this.ldapRoles];
  }
};
let UserRespMsg$1 = class UserRespMsg {
  constructor(user) {
    this.user = user;
  }
};
let Debug$1 = class Debug {
  constructor(message, line, file) {
    this.message = message;
    this.line = line;
    this.file = file;
  }
};
let Error$1 = class Error {
  constructor(code, message, debug, data) {
    this.code = code;
    this.message = message;
    this.debug = debug;
    this.data = data;
  }
};
let TokenErrorMsg$1 = class TokenErrorMsg {
  constructor(error) {
    this.error = error;
  }
};
const Rtl2ApiSsoEndpoints = {
  LoginPage: '/view/login',
  GetUserStatus: '/user/status',
  GetUser: '/user/get'
};
let Rtl2ApiSsoService = /*#__PURE__*/(() => {
  class Rtl2ApiSsoService {
    constructor(http, externalService) {
      this.http = http;
      this.externalService = externalService;
      this.apiServiceUrl = this.externalService.environmentGet('urlSsoB2bWebServer');
    }
    getLoginUrl() {
      return this.apiServiceUrl + Rtl2ApiSsoEndpoints.LoginPage;
    }
    getUserProfile(userToken) {
      const options = {
        params: new HttpParams().append('token', userToken).append('includeApps', true)
      };
      return this.http.get(this.apiServiceUrl + Rtl2ApiSsoEndpoints.GetUser, options).pipe(map(u => new UserProfile$1({
        ...u.user
      })));
    }
    getUserStatus(userToken) {
      const options = {
        params: new HttpParams().append('token', userToken).append('includeApps', true)
      };
      return this.http.get(this.apiServiceUrl + Rtl2ApiSsoEndpoints.GetUserStatus, options).pipe(catchError(err => {
        const errorMessage = this.externalService.handleError(err);
        this.externalService.logError('TOKEN validation failed:\n' + errorMessage.body, this.constructor.name);
        return of(null);
      }));
    }
    static {
      this.ɵfac = function Rtl2ApiSsoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ApiSsoService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(Rtl2SsoInterface));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2ApiSsoService,
        factory: Rtl2ApiSsoService.ɵfac
      });
    }
  }
  return Rtl2ApiSsoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2ApiSsoModule = /*#__PURE__*/(() => {
  class Rtl2ApiSsoModule {
    static forRoot() {
      return {
        ngModule: Rtl2ApiSsoModule,
        providers: [Rtl2ApiSsoService]
      };
    }
    static {
      this.ɵfac = function Rtl2ApiSsoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2ApiSsoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2ApiSsoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return Rtl2ApiSsoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const USER_ROLES = {
  PressTextEditor: 'ISY_User_Press_Text_Editor',
  PressReleaseEditor: 'ISY_User_Press_Release_Editor',
  HiglightEditor: 'ISY_User_Highlight_Editor',
  BroadcastWeektEditor: 'ISY_User_Broadcast_Week_Publisher',
  ImageManagementEditor: 'ISY_User_Image_Editor',
  PressImageEditor: 'ISY_User_Press_Image_Editor',
  ImageManagementAdmin: 'ISY_User_Image_Admin',
  TvNowPublisher: 'ISY_User_TV_NOW_Publisher'
};
class Status {
  constructor(token, userId, uid, app, access, created, rtl2Roles) {
    this.token = token;
    this.userId = userId;
    this.uid = uid;
    this.app = app;
    this.access = access;
    this.created = created;
    this.rtl2Roles = rtl2Roles;
  }
}
class StatusRespMsg {
  constructor(status) {
    this.status = status;
  }
}
class UserProfile {
  constructor(init) {
    Object.assign(this, init);
    this.ldapRoles = this.ldapRoles || [];
    this.pkvwRoles = this.pkvwRoles || [];
    this.rtl2Roles = this.rtl2Roles || [...this.pkvwRoles, ...this.ldapRoles];
  }
}
class UserRespMsg {
  constructor(user) {
    this.user = user;
  }
}
class Debug {
  constructor(message, line, file) {
    this.message = message;
    this.line = line;
    this.file = file;
  }
}
class Error {
  constructor(code, message, debug, data) {
    this.code = code;
    this.message = message;
    this.debug = debug;
    this.data = data;
  }
}
class TokenErrorMsg {
  constructor(error) {
    this.error = error;
  }
}
const STORAGE_SSO_TOKEN = 'sso_token';
const STORAGE_SSO_SECRET = 'sso_secret';
const STORAGE_PREVIOUS_URL = 'previous_url';
const STORAGE_USER_PROFILE = 'sso_user_profile';
const STORAGE_USER_ROLES = 'sso_user_roles';
const SSO_QUERY_PARAM_TOKEN = 'token';
const SSO_QUERY_PARAM_SSO_SECRET = 'ssoSecret';
let Rtl2SsoService = /*#__PURE__*/(() => {
  class Rtl2SsoService {
    static getUserProfileFromLocalStorage() {
      const profile = localStorage.getItem(STORAGE_USER_PROFILE);
      return new UserProfile(JSON.parse(profile));
    }
    static getUserRoles() {
      const rolesArray = localStorage.getItem(STORAGE_USER_ROLES);
      return JSON.parse(rolesArray) || [];
    }
    static getUserRolesObserve() {
      let i = 0;
      const result = new BehaviorSubject(null);
      const run = () => {
        if (i > 4) {
          result.next([]);
          return;
        }
        if (localStorage.hasOwnProperty(STORAGE_USER_ROLES)) {
          const rolesArray = localStorage.getItem(STORAGE_USER_ROLES);
          result.next(JSON.parse(rolesArray) || []);
          return;
        }
        i++;
        setTimeout(run, 2000);
      };
      run();
      return result.pipe(filter(v => v !== null));
    }
    static setUserRoles(roles) {
      localStorage.setItem(STORAGE_USER_ROLES, JSON.stringify(roles));
    }
    constructor(router, activeRoute, ssoApiService, externalService, document) {
      this.router = router;
      this.activeRoute = activeRoute;
      this.ssoApiService = ssoApiService;
      this.externalService = externalService;
      this.document = document;
      this.TAG = 'Rtl2SsoService';
      this.destroy$ = new Subject();
      this.isAuthenticated$ = new BehaviorSubject(false);
      this.hasUserAppRoles$ = new BehaviorSubject(false);
      this.userStatus$ = new BehaviorSubject(null);
      this.hasViewPermission$ = new BehaviorSubject(false);
      this.checkViewPermission();
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    handleAuth() {
      const prevUrl = localStorage.getItem(STORAGE_PREVIOUS_URL);
      if (this.router.url.startsWith('/auth/callback')) {
        this.takeActionOnAuth(prevUrl);
      }
    }
    takeActionOnAuth(prevUrl) {
      // Read query params of current url
      const params = this.activeRoute.snapshot.queryParamMap;
      const ssoToken = params.get(SSO_QUERY_PARAM_TOKEN);
      const ssoSecret = params.get(SSO_QUERY_PARAM_SSO_SECRET);
      if (!!ssoToken && !!ssoSecret) {
        this.saveAuth(ssoToken, ssoSecret, prevUrl);
      }
    }
    saveAuth(ssoToken, ssoSecret, prevUrl) {
      localStorage.setItem(STORAGE_SSO_TOKEN, ssoToken);
      localStorage.setItem(STORAGE_SSO_SECRET, ssoSecret);
      localStorage.removeItem(STORAGE_PREVIOUS_URL);
      this.router.navigate([prevUrl]);
      this.setLoggedIn(true);
    }
    validateForRoute(redirectUrl) {
      const token = this.getToken();
      return !token ? this.handleMissingToken(redirectUrl) : this.handleTokenValidation(token, redirectUrl);
    }
    handleMissingToken(redirectUrl) {
      this.setLoggedIn(false);
      this.redirectToSignIn(redirectUrl);
      return of(false);
    }
    handleTokenValidation(token, redirectUrl) {
      return this.validateSsoToken(token).pipe(map(data => {
        if (!data || typeof data.status === typeof true) {
          this.handleExpiredToken(redirectUrl, data);
          return false;
        } else {
          this.handleValidToken(data);
        }
        return true;
      }));
    }
    handleExpiredToken(redirectUrl, data) {
      const responseMessage = !data ? 'null' : JSON.stringify(data.status);
      this.externalService.logInfo(`Stored SSO TOKEN is expired! Response message:\n${responseMessage}`, this.TAG);
      this.setLoggedIn(false);
      this.redirectToSignIn(redirectUrl);
    }
    handleValidToken(data) {
      this.externalService.logInfo('SSO confirmed TOKEN is valid! Response message:\n' + JSON.stringify(data.status), this.TAG);
      const ssoResponse = data.status;
      localStorage.setItem(STORAGE_SSO_TOKEN, ssoResponse.token);
      this.setUserRoles(ssoResponse.rtl2Roles);
      this.setLoggedIn(true, ssoResponse);
    }
    checkRole(roles) {
      return !roles.length || Rtl2SsoService.getUserRoles().some(rtl2role => !!roles.find(r => r === rtl2role));
    }
    checkRoleObserve(roles) {
      return Rtl2SsoService.getUserRolesObserve().pipe(map(userRoles => !roles.length || userRoles.some(rtl2role => !!roles.find(r => r === rtl2role))), takeUntil(this.destroy$));
    }
    redirectUnauthorized(role) {
      this.router.navigate(['error403'], {
        queryParams: {
          missingRole: role
        }
      }).catch(() => this.document.location.href = this.externalService.environmentGet('urlBase') + '/error403?missingRole=' + role);
    }
    redirectToSignIn(prevUri) {
      localStorage.setItem(STORAGE_PREVIOUS_URL, prevUri.toString());
      const callbackUrl = this.externalService.environmentGet('appUrl') + '/auth/callback';
      const appId = this.externalService.environmentGet('appId');
      const params = `?appId=${appId}&loginRedirect=${encodeURIComponent(callbackUrl)}`;
      this.externalService.logInfo('REDIRECT from: ' + prevUri.toString(), this.TAG);
      this.document.location.href = this.ssoApiService.getLoginUrl() + params;
    }
    /**
     * Reads the token from the browsers local storage. When no token is found the method returns null,
     * otherwise it will return the token as a string.
     * @returns
     */
    getToken() {
      const token = localStorage.getItem(STORAGE_SSO_TOKEN);
      if (token === 'undefined') {
        this.externalService.logInfo('TOKEN is undefined.', this.TAG);
        return null;
      }
      return token;
    }
    getUserProfile() {
      return this.ssoApiService.getUserProfile(this.getToken()).pipe(tap(userProfile => localStorage.setItem(STORAGE_USER_PROFILE, JSON.stringify(userProfile))), takeUntil(this.destroy$));
    }
    getUserProfileFromLocalStorage() {
      const profile = localStorage.getItem(STORAGE_USER_PROFILE);
      return new UserProfile(JSON.parse(profile));
    }
    logout(injectedWindow = window) {
      // Remove tokens and ssoSecret and update login status subject
      localStorage.removeItem(STORAGE_SSO_TOKEN);
      localStorage.removeItem(STORAGE_SSO_SECRET);
      localStorage.removeItem(STORAGE_USER_PROFILE);
      localStorage.removeItem(STORAGE_USER_ROLES);
      this.setLoggedIn(false);
      this.document.location.href = this.externalService.environmentGet('urlSsoB2bWebServer') + '/view/logout';
      return true;
    }
    setLoggedIn(value, userStatus) {
      // Update login status subject
      this.externalService.logDebug('Login state set: ' + value, this.TAG);
      this.userStatus$.next(userStatus);
      this.isAuthenticated$.next(value);
    }
    getUserRoles() {
      return Rtl2SsoService.getUserRoles();
    }
    setUserRoles(roles) {
      Rtl2SsoService.setUserRoles(roles);
    }
    validateSsoToken(token) {
      return this.ssoApiService.getUserStatus(token);
    }
    setHasUserAppRoles(value) {
      this.hasUserAppRoles$.next(value);
    }
    checkAuthUrl(url) {
      return this.validateForRoute(url || this.router.routerState.snapshot.url).pipe(switchMap(r => r ? this.checkUserRoles() : of(false)), takeUntil(this.destroy$));
    }
    checkUserRoles() {
      return forkJoin([this.externalService.getMenuRolesCurrent(), this.externalService.menu]).pipe(switchMap(([roles]) => combineLatest([this.checkRoleObserve(roles), of(roles)])), tap(([hasRoles, roles]) => !hasRoles && this.redirectUnauthorized(roles.join(', '))), map(([hasRoles]) => {
        this.setHasUserAppRoles(!!hasRoles);
        return !!hasRoles;
      }), takeUntil(this.destroy$));
    }
    async checkViewPermission() {
      const hasAuthCanMatch = snap => {
        return !snap ? false : !snap.routeConfig?.canMatch?.some(v => v?.name === 'Rtl2AuthCanMatch') ? hasAuthCanMatch(snap.firstChild) : true;
      };
      await firstValueFrom(this.router.events.pipe(filter(e => e instanceof NavigationEnd), switchMap(() => combineLatest([this.isAuthenticated$, this.hasUserAppRoles$])), tap(([ia, huar]) => this.hasViewPermission$.next(!hasAuthCanMatch(this.router.routerState.snapshot.root) || ia && huar))));
    }
    static {
      this.ɵfac = function Rtl2SsoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SsoService)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i1$1.ActivatedRoute), i0.ɵɵinject(Rtl2ApiSsoService), i0.ɵɵinject(Rtl2SsoInterface), i0.ɵɵinject(DOCUMENT));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: Rtl2SsoService,
        factory: Rtl2SsoService.ɵfac
      });
    }
  }
  return Rtl2SsoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let Rtl2SsoCallbackComponent = /*#__PURE__*/(() => {
  class Rtl2SsoCallbackComponent {
    constructor(sso, externalService) {
      this.sso = sso;
      this.externalService = externalService;
      this.TAG = 'CallbackHandlerComponent';
      this.externalService.logInfo(this.TAG, 'loaded');
      this.sso.handleAuth();
    }
    static {
      this.ɵfac = function Rtl2SsoCallbackComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SsoCallbackComponent)(i0.ɵɵdirectiveInject(Rtl2SsoService), i0.ɵɵdirectiveInject(Rtl2SsoInterface));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: Rtl2SsoCallbackComponent,
        selectors: [["ng-component"]],
        decls: 0,
        vars: 0,
        template: function Rtl2SsoCallbackComponent_Template(rf, ctx) {},
        encapsulation: 2
      });
    }
  }
  return Rtl2SsoCallbackComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const Rtl2AuthCanMatch = () => {
  const document = inject(DOCUMENT);
  const sso = inject(Rtl2SsoService);
  const {
    href,
    origin
  } = document?.location;
  const url = href?.replace(origin, '');
  return sso.checkAuthUrl(url);
};
let Rtl2SsoModule = /*#__PURE__*/(() => {
  class Rtl2SsoModule {
    static forRoot() {
      return {
        ngModule: Rtl2SsoModule,
        providers: [Rtl2SsoService]
      };
    }
    static {
      this.ɵfac = function Rtl2SsoModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || Rtl2SsoModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: Rtl2SsoModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, Rtl2ApiSsoModule.forRoot()]
      });
    }
  }
  return Rtl2SsoModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// Services

/**
 * Generated bundle index. Do not edit.
 */

export { Debug$1 as Debug, Error$1 as Error, Rtl2ApiSsoEndpoints, Rtl2ApiSsoModule, Rtl2ApiSsoService, Rtl2AuthCanMatch, Rtl2SsoCallbackComponent, Rtl2SsoInterface, Rtl2SsoModule, Rtl2SsoService, SSO_QUERY_PARAM_SSO_SECRET, SSO_QUERY_PARAM_TOKEN, STORAGE_PREVIOUS_URL, STORAGE_SSO_SECRET, STORAGE_SSO_TOKEN, STORAGE_USER_PROFILE, STORAGE_USER_ROLES, Status$1 as Status, StatusRespMsg$1 as StatusRespMsg, TokenErrorMsg$1 as TokenErrorMsg, UserProfile$1 as UserProfile, UserRespMsg$1 as UserRespMsg };
